import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { InternalLibImage } from "../../../model/image-internal.class";
import { ModalGalleryService } from "../../modal-gallery/modal-gallery.service";
import { Observable } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-item-video-modal-gallery",
  standalone: true,
  imports: [],
  templateUrl: "./item-video-modal-gallery.component.html",
  styleUrl: "./item-video-modal-gallery.component.scss",
})
export class ItemVideoModalGalleryComponent implements OnInit, AfterViewInit {
  @ViewChild("videoRef") videoRef: ElementRef<HTMLVideoElement>;
  @Input() currentImage: InternalLibImage;
  @Output() contentLoaded = new EventEmitter();

  protected speed$: Observable<number>;
  private readonly modalGalleryService = inject(ModalGalleryService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.speed$ = this.modalGalleryService.speedVideo$;
  }

  ngAfterViewInit() {
    this.contentLoaded.emit();
    this.speed$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (speed) => {
        const video = this.videoRef?.nativeElement;
        if (video) {
          video.playbackRate = speed;
        }
      },
      () => {},
      () => {
        this.modalGalleryService.resetVideoSpeed();
      }
    );
  }
}
